import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, AlarmClock, Users, Lock } from 'lucide-react';
const TOTAL_CUPOS = 50;
const CUPOS_DISPONIBLES = 22;
export function UrgencyScarcitySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00'
  });
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      const diff = endOfDay.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({
          hours: '00',
          minutes: '00',
          seconds: '00'
        });
      } else {
        const h = Math.floor(diff / (1000 * 60 * 60) % 24);
        const m = Math.floor(diff / (1000 * 60) % 60);
        const s = Math.floor(diff / 1000 % 60);
        setTimeLeft({
          hours: h.toString().padStart(2, '0'),
          minutes: m.toString().padStart(2, '0'),
          seconds: s.toString().padStart(2, '0')
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const taken = TOTAL_CUPOS - CUPOS_DISPONIBLES;
  const progress = taken / TOTAL_CUPOS * 100;
  return <section className="px-4 py-10 md:py-14 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-467">
      <div className="w-full max-w-3xl relative rounded-[2.5rem] p-[2px] bg-gradient-to-b from-red-500/80 via-red-900/40 to-transparent shadow-[0_25px_60px_-15px_rgba(239,68,68,0.4)]" data-id="element-468">
        {/* Top neon line */}
        <div className="absolute -top-px left-1/2 -translate-x-1/2 w-[80%] h-[3px] bg-red-500 blur-[2px] rounded-full" data-id="element-469" />

        <div className="bg-gradient-to-b from-[#1a0606] via-[#120303] to-[#0a0202] rounded-[2.4rem] px-5 py-10 md:px-10 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-470">
          {/* Ambient red glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[500px] bg-red-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-471" />

          {/* Alert badge */}
          <motion.div animate={{
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 1.8,
          repeat: Infinity
        }} className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-[11px] md:text-sm uppercase tracking-[0.15em] px-6 py-3 rounded-full mb-8 shadow-[0_0_25px_rgba(239,68,68,0.6)] relative z-10" data-id="element-472">
            <Flame size={16} strokeWidth={2.5} className="fill-white/30" data-id="element-473" />
            ¡Atención! Oferta a punto de finalizar
          </motion.div>

          {/* Heading */}
          <h2 className="font-black text-[30px] md:text-[48px] leading-[1.05] tracking-tight uppercase text-white relative z-10 drop-shadow-[0_0_15px_rgba(239,68,68,0.4)]" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-474">
            Aprovechá el{' '}
            <span className="text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.8)]" data-id="element-475">
              50% OFF
            </span>
            <br data-id="element-476" />
            antes de que termine
          </h2>

          <p className="text-white/60 text-sm md:text-base font-medium max-w-lg mt-5 mb-10 relative z-10 leading-relaxed" data-id="element-477">
            Esta promoción es exclusiva y limitada. Cuando el reloj llegue a
            cero o se agoten los cupos, Fórmula UGC vuelve al precio regular.
          </p>

          {/* Timer Card */}
          <div className="w-full border border-red-500/30 bg-red-950/20 rounded-[1.75rem] p-6 md:p-8 mb-6 relative z-10" data-id="element-478">
            <div className="inline-flex items-center gap-2 text-red-400 font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] mb-6" data-id="element-479">
              <AlarmClock size={16} strokeWidth={2.5} data-id="element-480" />
              La oferta expira en
            </div>
            <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-481">
              <TimerBox value={timeLeft.hours} label="Horas" data-id="element-482" />
              <span className="text-red-500 font-black text-2xl md:text-4xl mt-[-18px]" data-id="element-483">
                :
              </span>
              <TimerBox value={timeLeft.minutes} label="Minutos" data-id="element-484" />
              <span className="text-red-500 font-black text-2xl md:text-4xl mt-[-18px]" data-id="element-485">
                :
              </span>
              <TimerBox value={timeLeft.seconds} label="Segundos" data-id="element-486" />
            </div>
          </div>

          {/* Cupos Card */}
          <div className="w-full border border-red-500/30 bg-red-950/20 rounded-[1.75rem] p-6 md:p-8 mb-8 relative z-10" data-id="element-487">
            <div className="inline-flex items-center gap-2 text-red-400 font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] mb-4" data-id="element-488">
              <Users size={16} strokeWidth={2.5} data-id="element-489" />
              Cupos disponibles
            </div>
            <p className="font-black text-white text-[44px] md:text-[60px] leading-none mb-5 drop-shadow-[0_0_15px_rgba(239,68,68,0.4)]" data-id="element-490">
              {CUPOS_DISPONIBLES}{' '}
              <span className="text-white/40 text-2xl md:text-3xl font-bold" data-id="element-491">
                / {TOTAL_CUPOS}
              </span>
            </p>
            {/* Progress bar */}
            <div className="w-full h-3 rounded-full bg-red-950/60 border border-red-500/20 overflow-hidden mb-4" data-id="element-492">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${progress}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.2,
              ease: 'easeOut'
            }} className="h-full rounded-full bg-gradient-to-r from-red-700 via-red-500 to-red-400 shadow-[0_0_15px_rgba(239,68,68,0.6)]" data-id="element-493" />
            </div>
            <p className="text-white/50 text-sm md:text-base font-medium" data-id="element-494">
              Se están agotando rápido —{' '}
              <strong className="text-red-400 font-bold" data-id="element-495">
                {taken} ya tomados
              </strong>
            </p>
          </div>

          {/* Footer warning */}
          <div className="flex items-start md:items-center gap-2 text-white/70 text-[13px] md:text-base font-medium relative z-10 text-left md:text-center" data-id="element-496">
            <Lock size={16} strokeWidth={2.5} className="text-red-400 shrink-0 mt-0.5 md:mt-0" data-id="element-497" />
            <span data-id="element-498">
              Una vez que el contador llegue a 00:00,{' '}
              <strong className="text-red-400 font-bold" data-id="element-499">
                esta oferta desaparece
              </strong>{' '}
              y el precio vuelve a{' '}
              <span className="line-through text-white/40" data-id="element-500">$149.999 ARS</span>.
            </span>
          </div>
        </div>
      </div>
    </section>;
}
function TimerBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-501">
      <div className="bg-[#0a0202] border border-red-500/40 rounded-xl w-16 h-16 md:w-24 md:h-24 flex items-center justify-center shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-502">
        <span className="text-red-400 font-black text-3xl md:text-5xl font-mono drop-shadow-[0_0_12px_rgba(239,68,68,0.7)]" data-id="element-503">
          {value}
        </span>
      </div>
      <span className="text-white/50 font-semibold text-[9px] md:text-xs mt-2 tracking-widest uppercase" data-id="element-504">
        {label}
      </span>
    </div>;
}